import React from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';


import Ficha from './componentes/Ficha';
import Login from './Login';
import Registro from './componentes/Registro';
import UploaderDocument from './componentes/UploaderDocument';
import FichaMatricula from './componentes/FichaMatricula';
import VerPdf from './componentes/VerPdf';

const App = () =>{
  return (
    <>
{/*       <Helmet>
        <title>Login</title>
      </Helmet> */}
      <BrowserRouter>
      <div>
        <main>
          <Routes  >
              <Route path="/" element={<Login />}/>  
              <Route path="/ficha" element={
              <Ficha
                guid_oportunidad = {''}
              />
            }/>   
              <Route path="/registrado" element={
              <Registro
                ficha_matricula = {''}
                urlapi = {''}
                usuarioAct = {''}
              />
            }/>
              <Route path="/UploaderDocument" element={
              <UploaderDocument
                guid = {''}
                idTipoDoc = {''}
                tipoDoc = {''}
/*              ficha_matricula = {''}
                urlapi = {''}
                usuarioAct = {''} */
              />
            }/>
            <Route path="/FichaMatricula" element={<FichaMatricula   guid_oportunidad = {''} />}/>
 
            <Route path="/VerPdf" element={<VerPdf   guid_oportunidad = {''} />}/>
             
          </Routes>
        </main>      
      </div>
      </BrowserRouter>
    </>

  );
}
export default App;